<script>

import {fix, formatTime} from '../../../utils'

export default {
  props: ['setCountSelectValue', 'countSelectValue'],
  data () {
    return {
      // countSelectValue: 0
      event_buf: ['A相过电压', 'B相过电压', 'C相过电压', 'A相欠电压', 'B相欠电压', 'C相欠电压', 'A相过电流', 'B相过电流', 'C相过电流', 'A相功率因数越限', 'B相功率因数越限', 'C相功率因数越限', 'A相电压THD越限', 'B相电压THD越限', 'C相电压THD越限', 'A相电流THD越限', 'B相电流THD越限', 'C相电流THD越限', 'A相频率越限', 'B相频率越限', 'C相频率越限', '电压不平衡度越限', '电流不平衡度越限', '漏电流越限']
    }
  },
  computed: {
    eventData () {
      return this.$store.state.eventData
    }
  },
  methods: {
    formatTime,
    fix
    // chosen (index) {
    //   this.countSelectValue = index
    //   this.setCountSelectValue(index)
    // }
    // chooseFaultType (data) {
    //   switch (data) {
    //     case 1:
    //       return '漏电流越限'
    //     case 2:
    //       return '电压不平衡度越限'
    //     case 4:
    //       return '电流不平衡度越限'
    //     case 8:
    //       return '频率越限'
    //     case 16:
    //       return '电流THD越限'
    //     case 32:
    //       return '相电压THD越限'
    //     case 64:
    //       return '功率因数越限'
    //     case 128:
    //       return 'C相过流'
    //     case 256:
    //       return 'B相过流'
    //     case 512:
    //       return 'A相过流'
    //     case 1024:
    //       return 'C相过压'
    //     case 2048:
    //       return 'B相过压'
    //     case 4096:
    //       return 'A相过压'
    //     case 8192:
    //       return 'C相欠压'
    //     case 16384:
    //       return 'B相欠压'
    //     case 32768:
    //       return 'A相欠压'
    //   }
    // }
  }
}
</script>

<template>
  <div class="pg">
    <!--      功率因数-->
    <div class="dataItems">
      <div class="title">电能质量事件记录(点击查看详情)</div>
      <div class="dataItem">
        <div class="dataTitle"
             style="margin: 0 10px; border-bottom: 1px solid #c2c2c2; border-top: 1px solid #c2c2c2; width: calc(100% - 37px); font-weight: 600; color: black;">
          <div class="ItemIndex" style="width: 25%; border-right: 1px solid #c2c2c2">序号</div>
          <div class="ItemLvalue" style="width: 25%; border-right: 1px solid #c2c2c2">发生时刻</div>
          <div class="ItemSvalue" style="width: 25%; border-right: 1px solid #c2c2c2">类型</div>
          <div class="ItemSvalue" style="width: 25%;">
            持续时间(s)
          </div>
        </div>
        <div style="overflow: auto; height: calc(100% - 70px); width: calc(100% - 37px);">
          <div class="dataBody" v-for="(item, index) in eventData" :key="index"
               style="margin: 0 10px; border-bottom: 1px solid #c2c2c2; cursor: pointer;"
               @click="setCountSelectValue(index)" :style="index===countSelectValue? 'background: #e0e0e0': ''">
            <div class="ItemIndex" style="width: 25%;">{{ index + 1 }}</div>
            <div class="ItemLvalue" style="width: 25%;">
              <div>{{ formatTime(item.event_time * 1000, 'yyyy/MM/dd') }}</div>
              <div>{{ formatTime(item.event_time * 1000, 'HH:mm:ss') }}</div>
              <!--              <div>{{ formatTime(new Date(), 'yyyy/MM/dd') }}</div>-->
              <!--              <div>{{ formatTime(new Date(), 'HH:mm:ss') }}</div>-->
            </div>
            <div class="ItemSvalue" style="width: 25%;">
              {{ event_buf[item.event_type - 1] }}
            </div>
            <div class="ItemSvalue" style="width: 25%;">
              {{ item.event_cont_time }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/transient.css";

.pg {
  height: calc(90vh - 80px);
}

.dataBody {
  height: calc(100% / 8);
}
</style>



// WEBPACK FOOTER //
// src/pages/Event/EventLog/EventLog.vue